"use client";

import { queryClient } from "@/lib/query-client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense } from "react";
import { Toaster } from "sonner";
import { PostHogProvider } from "./posthog-provider";
import { GoogleAnalyticsProvider } from "./google-analytics-provider";

type UserData = {
  id: number;
  name: string;
  email: string;
  profile_photo_url: string;
};

export default function QueryProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Toaster className="font-sans" />
      <Suspense fallback={null}>
        <GoogleAnalyticsProvider />
      </Suspense>
      <PostHogProvider>
        <QueryClientProvider client={queryClient}>
          {children}
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </PostHogProvider>
    </>
  );
}
